var historyBlock = (function () {

	var scrollWrapper, items, currentItem, itemWidth, slider, sliderWidth;
	
	function setup() {
		scrollWrapper = $('.scroll-wrapper', '.block-historyBlock');
		slider = $('.scroll-bar .slider');
		var scrollBarWidth = $('.scroll-bar').width();

		items = $('.history-item');
		sliderWidth = scrollBarWidth / (items.length-1);
		$(slider).css('width', sliderWidth + 'px');

		currentItem = 0;
		itemWidth = $('.history-item:first').outerWidth();

	//	scrollWrapper.css('width', itemWidth * items.length + 'px');

		//$(scrollWrapper).on('scroll', function () {
		//	$('.history-item').each(function(i, e) {
		//		if ($(e).position().left < 800 && $(e).position().left > -.5 * $(e).outerWidth()) {
		//			$(e).addClass('active');
		//		} else {
		//			$(e).removeClass('active');
		//		}
		//	});
		//});

		$('.scroll-bar').on('click', function (evt) {
			evt.preventDefault();
			if ($(evt.target).hasClass('slider')) return;

			if (evt.offsetX < $(slider).position().left) {
				$('.history-prev').click();
			} else if (evt.offsetX > $(slider).position().left + sliderWidth) {
				$('.history-next').click();
			}
		});

		var animating = false;
		$('.history-next').on('click', function (evt) {
			evt.preventDefault();
			if (animating) return;
			animating = true;
			if (currentItem == items.length - 2) {
				scrollWrapper.animate({ 'scrollLeft': items.length * itemWidth });
				return;
			}
			currentItem++;
			scrollWrapper.animate({ 'scrollLeft': scrollWrapper.scrollLeft() + itemWidth }, function () { animating = false; });
			slider.css('left', sliderWidth * currentItem + 'px');
		});

		var animatingR = false;
		$('.history-prev').on('click', function (evt) {
			evt.preventDefault();
			if (animatingR) return;
			animatingR = true;
			if (currentItem == 0) {
				scrollWrapper.animate({ 'scrollLeft': 0 });
				return;
			}
			currentItem--;
			scrollWrapper.animate({ 'scrollLeft': scrollWrapper.scrollLeft() - itemWidth }, function () { animatingR = false; });
			slider.css('left', sliderWidth * currentItem + 'px');
		});
	}

	return {
		init: function () {
			$(function () {
				setup();
			});
		}
	};
})();

export var historyBlock;